import React, { useEffect, useState } from 'react';
import { useBusiness } from '../contexts/BusinessContext';
import { useCart } from '../contexts/CartContext';
import WelcomeScreen from '../components/client/WelcomeScreen';
import MenuView from '../components/client/MenuView';
import CartView from '../components/client/CartView';
import CheckoutView from '../components/client/CheckoutView';

const CustomDomainView = ({ slug }) => {
  const { business, loading, error, loadBusiness } = useBusiness();
  const { setSlug, setDeliveryMode, setRoutePrefix } = useCart();
  const [initialized, setInitialized] = useState(false);

  const pathname = window.location.pathname.replace(/^\//, '').replace(/\/$/, '');

  useEffect(() => {
    if (!slug) return;
    setSlug(slug);
    setRoutePrefix(''); // Sin prefijo: rutas son /delivery, /carrito, /fin
    loadBusiness(slug).finally(() => setInitialized(true));
  }, [slug]);

  useEffect(() => {
    if (pathname === 'delivery') setDeliveryMode('delivery');
    else if (pathname === 'takeaway') setDeliveryMode('takeaway');
  }, [pathname]);

  if (!initialized || loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-black">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-yellow-400 mx-auto mb-4"></div>
          <p className="text-gray-400 text-sm">Cargando...</p>
        </div>
      </div>
    );
  }

  if (error || !business) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-black text-white">
        <div className="text-center space-y-3">
          <p className="text-2xl font-bold">Sitio no disponible</p>
          <p className="text-gray-400">No se pudo cargar el negocio.</p>
        </div>
      </div>
    );
  }

  const renderStep = () => {
    switch (pathname) {
      case 'delivery':
      case 'takeaway':
        return <MenuView />;
      case 'carrito':
        return <CartView />;
      case 'fin':
        return <CheckoutView />;
      default:
        return <WelcomeScreen />;
    }
  };

  return (
    <div className="min-h-screen" style={{ fontFamily: 'var(--font-body, Roboto, sans-serif)' }}>
      {renderStep()}
    </div>
  );
};

export default CustomDomainView;
